import React from "react";
import { PARTNER_LOGOS } from "../../lib/site-data";

const LogoChip = ({ name }) => (
  <div
    className="flex items-center gap-2.5 px-6 py-3.5 rounded-2xl border border-ink/10 bg-white shrink-0"
    data-testid={`logo-${name.toLowerCase().replace(/\s+/g, "-")}`}
  >
    <span className="inline-block h-2 w-2 rounded-full bg-forest" />
    <span className="font-display text-[15px] font-bold tracking-tight text-ink/85">
      {name}
    </span>
  </div>
);

export default function LogoCloud() {
  // Duplicate the list once to make a seamless marquee
  const loop = [...PARTNER_LOGOS, ...PARTNER_LOGOS];
  return (
    <section
      id="resources"
      data-testid="logo-cloud"
      className="bg-cream pb-20 lg:pb-24"
    >
      <div className="container-x">
        <p className="text-center text-[13px] font-semibold uppercase tracking-[0.2em] text-ink/55">
          Trusted by leading clinics, insurers and partners
        </p>
      </div>
      <div className="mt-10 marquee-mask overflow-hidden">
        <div className="flex w-max animate-marquee gap-4 will-change-transform">
          {loop.map((name, i) => (
            <LogoChip key={`${name}-${i}`} name={name} />
          ))}
        </div>
      </div>
    </section>
  );
}
